import { render } from "./TheProfessionalExpedientFile.vue?vue&type=template&id=c43416a0&scoped=true&ts=true"
import script from "./TheProfessionalExpedientFile.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalExpedientFile.vue?vue&type=script&lang=ts"

import "./TheProfessionalExpedientFile.vue?vue&type=style&index=0&id=c43416a0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c43416a0"]])

export default __exports__